import { useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useDevice } from '@atc/react-device';
import { SideBarToModal } from 'reaxl';
import OfferBreakdown from '../OfferBreakdown/OfferBreakdown.js';
import Disclaimer from '../Disclaimer/Disclaimer.js';
import ConfigContext from '../ConfigContext/ConfigContext.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
function OfferBreakdownModal(_ref) {
  let {
    container,
    isVisible = false,
    adjustedCapCost,
    downPayment,
    renderTaxesAndFees,
    tabName = 'finance',
    totalCashOut,
    totalFinancing,
    offerBreakdownProps = {},
    disclaimerPaymentProps,
    paymentErrorState = false,
    onHide = () => {},
    price,
    paymentsInfo,
    vehicleCondition,
    personalizedPayment,
    isLoading = false,
    hasError = false,
    taxesFees = {},
    showTotalTaxesOnly = false,
    isEstimate = false,
    isLease = false,
    hasTaxesFetchError = false
  } = _ref;
  const {
    disableIncentives = false,
    disableTrade = false,
    enableOfferUpgrades = true,
    enablePriceDetailsInOfferBreakdown = true,
    showMsrp = true
  } = useContext(ConfigContext) ?? {};
  const device = useDevice();
  const isXs = device?.is?.xs ?? false;
  const {
    getPricingBreakdown
  } = offerBreakdownProps;
  const pricingDetail = getPricingBreakdown(tabName);
  if (!pricingDetail || _isEmpty(pricingDetail)) {
    return null;
  }
  const monthlyPaymentProps = {
    price,
    paymentsInfo,
    vehicleCondition,
    personalizedPayment,
    isLoading
  };
  const taxesFeesSectionProps = {
    isLoading,
    hasError: hasError || paymentErrorState,
    taxesFees,
    showTotalTaxesOnly,
    isEstimate,
    isLease,
    isOfferBreakdownModal: true
  };
  const modalTitle = `${tabName.charAt(0).toUpperCase() + tabName.slice(1)} Offer Breakdown`;
  const showDisclaimer = !hasTaxesFetchError && !paymentErrorState && disclaimerPaymentProps && Object.keys(disclaimerPaymentProps).length > 0;
  return /*#__PURE__*/jsx(SideBarToModal, {
    container: container,
    title: modalTitle,
    content: /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(OfferBreakdown, {
        adjustedCapCost: adjustedCapCost,
        disableIncentives: disableIncentives,
        disableTrade: disableTrade,
        downPayment: downPayment,
        enableOfferUpgrades: enableOfferUpgrades,
        enablePriceBreakdown: enablePriceDetailsInOfferBreakdown,
        renderTaxesAndFees: renderTaxesAndFees,
        showMsrp: showMsrp,
        tabName: tabName,
        totalCashOut: totalCashOut,
        totalFinancing: totalFinancing,
        isModal: true,
        ...offerBreakdownProps,
        monthlyPaymentProps: monthlyPaymentProps,
        taxesFeesSectionProps: taxesFeesSectionProps,
        hasError: hasTaxesFetchError || paymentErrorState
      }), showDisclaimer && /*#__PURE__*/jsx(Disclaimer, {
        container: container,
        disclaimerPaymentProps: disclaimerPaymentProps,
        type: tabName,
        "data-cmp": "disclaimer",
        placement: "offerBreakdownModal"
      })]
    }),
    collapsed: isXs,
    show: isVisible,
    sideBarOptions: {
      fullWidth: true
    },
    modalOptions: {
      bsStyle: 'sm'
    },
    onHide: onHide
  });
}
export { OfferBreakdownModal as default };
